<script lang="ts">
  type Props = {
    streamLabel: string;
    onsubmit: (startLocal: string, endLocal: string) => void | Promise<void>;
    onclose: () => void;
  };
  let { streamLabel, onsubmit, onclose }: Props = $props();

  function pad(n: number): string {
    return String(n).padStart(2, '0');
  }
  function toLocal(d: Date): string {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  function preset(min: number): void {
    const end = new Date();
    const start = new Date(end.getTime() - min * 60_000);
    startVal = toLocal(start);
    endVal = toLocal(end);
  }

  let startVal = $state('');
  let endVal = $state('');
  let err = $state('');
  let busy = $state(false);

  preset(60);

  async function submit(e: Event): Promise<void> {
    e.preventDefault();
    err = '';
    if (!startVal || !endVal) { err = 'Заполни обе даты'; return; }
    if (new Date(endVal) <= new Date(startVal)) { err = 'Конец должен быть позже начала'; return; }
    busy = true;
    try {
      await onsubmit(startVal, endVal);
    } catch (e) {
      err = e instanceof Error ? e.message : String(e);
    } finally {
      busy = false;
    }
  }

  function onKeydown(e: KeyboardEvent): void {
    if (e.key === 'Escape') onclose();
  }
</script>

<svelte:window onkeydown={onKeydown} />

<div class="bg" onclick={(e) => { if (e.target === e.currentTarget) onclose(); }} role="presentation">
  <form class="modal" onsubmit={submit}>
    <h2>Архив</h2>
    <p class="muted">{streamLabel}</p>
    <div class="grid2">
      <label>Начало<input type="datetime-local" bind:value={startVal} required /></label>
      <label>Конец<input type="datetime-local" bind:value={endVal} required /></label>
    </div>
    <div class="presets">
      <button type="button" class="ghost" onclick={() => preset(15)}>−15 мин</button>
      <button type="button" class="ghost" onclick={() => preset(60)}>−1 час</button>
      <button type="button" class="ghost" onclick={() => preset(240)}>−4 часа</button>
      <button type="button" class="ghost" onclick={() => preset(1440)}>−24 часа</button>
    </div>
    <div class="err">{err}</div>
    <div class="actions">
      <button type="button" class="ghost" onclick={onclose}>Отмена</button>
      <button type="submit" class="primary" disabled={busy}>{busy ? 'Запрашиваю…' : 'Воспроизвести'}</button>
    </div>
  </form>
</div>

<style>
  .bg {
    position: fixed; inset: 0; z-index: 100;
    background: rgba(0,0,0,.45);
    backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px);
    display: flex; align-items: center; justify-content: center;
  }
  .modal {
    width: min(420px, calc(100vw - 32px));
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 24px;
    display: flex; flex-direction: column; gap: 14px;
  }
  h2 { font-size: 17px; font-weight: 600; letter-spacing: -.01em; margin: 0; }
  .muted { color: var(--fg-muted); margin: 0; font-size: 13px; }
  .grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  label { display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: var(--fg-muted); font-weight: 500; }
  input { padding: 8px 10px; border-radius: 8px; border: 1px solid var(--border); background: var(--bg-elev); color: var(--fg); }
  input:focus { outline: 2px solid var(--accent); outline-offset: -1px; border-color: var(--accent); }
  .presets { display: flex; gap: 6px; flex-wrap: wrap; }
  .err { color: var(--bad); font-size: 13px; min-height: 1.2em; }
  .actions { display: flex; gap: 10px; justify-content: flex-end; }
  button.primary { background: var(--accent); color: #fff; padding: 8px 14px; border-radius: 8px; font-weight: 500; }
  button.primary:hover:not(:disabled) { filter: brightness(1.08); }
  button.primary:disabled { opacity: .6; cursor: default; }
  button.ghost { color: var(--fg-muted); padding: 8px 14px; border-radius: 8px; font-weight: 500; }
  button.ghost:hover { color: var(--fg); }
</style>
